import React, { useState } from 'react';
import { SalvButton, SalvModal, Size } from '@salvapp/ui-components';
import { InternalApiNoteDraft } from '../api-internal';

interface DeleteDraftDialogProps {
  draft: InternalApiNoteDraft;
  show: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
}

export const DeleteNoteDraftDialog = ({ draft, show, onClose, onConfirm }: DeleteDraftDialogProps) => {
  const [isDeleting, setIsDeleting] = useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      await onConfirm();
      onClose();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <SalvModal show={show} onHide={onClose}>
      <SalvModal.Header closeButton>
        <span className='title-s'>Delete Draft?</span>
      </SalvModal.Header>
      <SalvModal.Body>
        <p>Are you sure you want to delete this draft? This action cannot be undone.</p>
        {draft.content && (
          <div className='p-3 bg-primary-soft rounded' style={{ maxHeight: '150px', overflow: 'auto' }}>
            <small className='text-muted'>
              {draft.content.length > 200 ? `${draft.content.substring(0, 200)}...` : draft.content}
            </small>
          </div>
        )}
      </SalvModal.Body>
      <SalvModal.Footer>
        <SalvButton label='Cancel' variant='muted' onClick={onClose} size={Size.MEDIUM} disabled={isDeleting} />
        <SalvButton
          label={isDeleting ? 'Deleting...' : 'Delete'}
          variant='danger'
          onClick={handleConfirm}
          size={Size.MEDIUM}
          disabled={isDeleting}
        />
      </SalvModal.Footer>
    </SalvModal>
  );
};
